

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      filtro_li: true,
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }

    };
  },


  
  computed: {
    reporte: function () {
      return '/estadisticas/ventas/tarjeta?dsis='+window.sssdi+'&a=resumenvtatarjeta' + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta

    }
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: []

    });
    $('.box').boxWidget();

    //this.consultar();

  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();

      let fl = 0;
      if (this.filtro_li) {
        fl = 1;
        var column2 = this.tbv.column(1)
        column2.visible(true);
      } else {
        fl = 0;
        var column2 = this.tbv.column(1)
        column2.visible(true);
      }



      this.$http
        .post('/estadisticas/ventas/tarjeta', this.f_c)
        .then(response => {

          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i][2] = this.num_to_many(response.data.data[i][2]);
              response.data.data[i][3] = this.num_to_many(response.data.data[i][3]);
              response.data.data[i][4] = this.num_to_many(response.data.data[i][4]);
              response.data.data[i][6] = this.num_to_many(response.data.data[i][6]);
              

              this.tbv.row.add(response.data.data[i]);

            }

          }
          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/estadisticas/resumenvtatarjeta/tventas/tventas.js